import Swal from 'sweetalert2';

const confirm = (text = 'Do you want to continue?', confirmButtonText = 'OK') => {
  return new Promise(function (resolve) {
    Swal.fire({
      text: text,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: confirmButtonText,
      customClass: {
        confirmButton: 'btn btn-success btn-lg',
        cancelButton: 'btn btn-primary btn-lg',
      },
    }).then((result) => {
      if (result.isConfirmed) {
        resolve(true);
      }
    });
  });
};

const confirmDanger = (text = 'Do you want to continue?') => {
  return new Promise(function (resolve) {
    Swal.fire({
      text: text,
      icon: 'error',
      showCancelButton: true,
      customClass: {
        confirmButton: 'btn btn-danger btn-lg',
        cancelButton: 'btn btn-secondary btn-lg',
      },
    }).then((result) => {
      if (result.isConfirmed) {
        resolve(true);
      }
    });
  });
};

const confirmApplyToAll = (text = 'Do you want to apply this to all users in the shop?') => {
  return new Promise(function (fulfill, reject) {
    Swal.fire({
      title: 'Apply to All Users?',
      text: text,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, Apply to All',
      cancelButtonText: 'No, Just This User',
      customClass: {
        confirmButton: 'btn btn-warning btn-lg',
        cancelButton: 'btn btn-secondary btn-lg',
      },
    }).then((result) => {
      if (result.isConfirmed) {
        fulfill(true);
      }
      reject(false);
    });
  });
};

export { confirm, confirmDanger, confirmApplyToAll };
